import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Country } from '../../models/country/country-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class CountryService {

  private serviceName = 'api/country';
  constructor(private http: Http, private cookieService: CookieService) {

  }

  getCountries() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addCountry(countryModel: Country) {

    return this.http
      .post(`${this.serviceName}/InsertCountry`, countryModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  updateCountry(countryModel: Country) {
    return this.http.post(`${this.serviceName}/UpdateCountry`, countryModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteCountry(id: string) {
    return this.http.get(`${this.serviceName}/DeleteCountry?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getCountry(countryId: string) {
    return this.http.get(`${this.serviceName}/GetCountryById?id=` + countryId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/country/country.service.ts